import React from "react"

import { useTranslation } from "@bounce/i18n"

import { FAQs as BaseFAQs } from "../../../../components/Generic/FAQs/FAQs"
import type { FAQ } from "../../../../utils/boilerplate"

export type EventsProps = {
  faqs: FAQ[]
  className?: string
}

export const FAQs = ({ faqs, className }: EventsProps) => {
  const [t] = useTranslation("marketing-ls-event")
  const parsedFaqs = faqs.filter(faq => faq.id !== "")

  return <BaseFAQs title={t("screen.event.faqTitle", "All you need to know")} faqs={parsedFaqs} className={className} />
}
